


// InviteDetails.jsx
import React from 'react';
import { Box,Button, Avatar } from '@mui/material';
import { useMediaQuery ,CircularProgress} from '@mui/material';
import invited from '../../../../assets/Dashboard/invited.svg';
// import novacore from '../../../assets/novacore.png';
import profileperson from '../../../../assets/profileperson.png';
import back from "../../../../assets/back.svg"
import CustomText, { textStyles } from '../../../../components/CustomText';
import trial from "../../../../assets/Dashboard/trial.svg";
import company from "../../../../assets/company.png";
import code from "../../../../assets/code.svg";
import CustomButton from "../../../../components/CustomButton";
import request from "../../../../assets/Dashboard/request.svg";
import active from "../../../../assets/Dashboard/active.svg";
import clienttrial from "../../../../assets/Dashboard/clienttrial.svg";

import inactive from '../../../../assets/Dashboard/inactive.svg';
import process from "../../../../assets/Dashboard/process.svg";
import overdue from "../../../../assets/Dashboard/overdue.svg";
import received from "../../../../assets/Wallet/received.svg";
import pending from "../../../../assets/Wallet/pending.svg";
import { useTranslation } from 'react-i18next';
import { BASE_URL } from "../../../../components/BaseUrl"
import { decryptToken } from "../../../../Utlis/Encryption";
import {toast,Toaster} from "react-hot-toast";
import { useState,useEffect } from 'react';
import StatusDropdown from '../../../../components/StatusDropdown';
import dummy from "../../../../assets/dummy.png";
import imageIcon from "../../../../assets/imageIcon.png";
import document1 from "../../../../assets/document1.svg";
import { convertUTCToLocalDateTime } from "../../../../components/dateTime";
const textStyle = {
  label: { fontWeight: 500, fontSize: 13.5, color: '#344054', lineHeight: '28px' },
  value: { fontWeight: 600, fontSize: 13.5, color: '#101828', lineHeight: '28px' },
};

const ClientsTrialDetails= ({ selectedRow, onClose }) => {
      const isMobile = useMediaQuery('(max-width:768px)');
       const { t } = useTranslation();
         const rawEncryptedToken = localStorage.getItem("token")
         const token = rawEncryptedToken ? decryptToken(rawEncryptedToken) : null
 const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(true);

const [profileImgSrc, setProfileImgSrc] = React.useState(dummy);
const [companyLogoSrc, setCompanyLogoSrc] = React.useState(dummy);
const loadImageWithAuth = async (url, setter) => {
  try {
    const res = await fetch(url, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    if (!res.ok) throw new Error("Image fetch failed");
    const blob = await res.blob();
    const objectUrl = URL.createObjectURL(blob);
    setter(objectUrl);
  } catch (err) {
    console.error("Image error:", err);
    setter(dummy);
  }
};

React.useEffect(() => {
  if (!details) return;

  const profileUrl = details?.account_details?.profile_image;
  const companyUrl = details?.company_details?.company_logo;

  console.log("DETAILS -> profile_image:", profileUrl);
  console.log("DETAILS -> company_logo:", companyUrl);

  if (profileUrl) loadImageWithAuth(profileUrl, setProfileImgSrc);
  if (companyUrl) loadImageWithAuth(companyUrl, setCompanyLogoSrc);
}, [details, token]);


           useEffect(() => {
    const fetchDetails = async () => {
      try {
        const response = await fetch(`${BASE_URL}/company-admins/${selectedRow.id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });
        const json = await response.json();
        if (!json.error && json.data?.company_admin) {
          setDetails(json.data.company_admin);
        } else {
          toast.error(json.message || "Failed to load company admin details.");
        }
      } catch (err) {
        toast.error("Network error while fetching details.");
      } finally {
        setLoading(false);
      }
    };

    if (selectedRow?.id) {
      fetchDetails();
    }
  }, [selectedRow?.id]);

const statusIcons = {
  Active: active,
  Trial: trial,
  Invited: invited,
  Inactive: inactive,
  Requested: request,
  Overdue:overdue,
   Processing:process,
   Paid:active,
   Pending:pending,
    Received:received,
      active: active,
  trial: trial,
  invited: invited,
  inactive: inactive,
  requested: request,
  overdue:overdue,
   processing:process,
   paid:active,
   pending:pending,
    received:received

};

const statusStyles = {
  Active: { backgroundColor: '#4BCE97', color: '#164B35' },
  Trial: { backgroundColor: '#FEA362', color: '#702E00' },
  Invited: { backgroundColor: '#579DFF', color: '#09326C' },
  Inactive: { backgroundColor: '#F87168', color: '#5D1F1A' },
  Requested: { backgroundColor: '#F5CD47', color: '#533F04' },
    Paid: { backgroundColor: '#4CD08B', color: '#0E563F' },
  Processing: { backgroundColor: '#FDD35C', color: '#7A4100' },
  Overdue: {backgroundColor: '#FFA26B', color: '#722800' },
   Pending: {  backgroundColor: '#F5CD47',  color: '#533F04', },
    Received: {  backgroundColor: '#4BCE97', color: '#164B35',  },
     active: { backgroundColor: '#4BCE97', color: '#164B35' },
  trial: { backgroundColor: '#FEA362', color: '#702E00' },
  invited: { backgroundColor: '#579DFF', color: '#09326C' },
  inactive: { backgroundColor: '#F87168', color: '#5D1F1A' },
  requested: { backgroundColor: '#F5CD47', color: '#533F04' },
    paid: { backgroundColor: '#4CD08B', color: '#0E563F' },
  processing: { backgroundColor: '#FDD35C', color: '#7A4100' },
  overdue: {backgroundColor: '#FFA26B', color: '#722800' },
   pending: {  backgroundColor: '#F5CD47',  color: '#533F04', },
    received: {  backgroundColor: '#4BCE97', color: '#164B35',  }
};
if (loading) {
  return (
    <Box sx={{
      height: 'calc(100vh - 100px)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }}>
      <CircularProgress size={40} sx={{ color: "#006EC2" }} />
    </Box>
  );
}



const formatSubscription = (value) => {
  if (!value) return "";

  return value
    .replace(/_/g, " ")      // full_monthly → full monthly
    .replace(/\b\w/g, (c) => c.toUpperCase()); // capitalize each word
};

const formatDateTime = (date) => {
  if (!date) return "";

  return new Date(date)
    .toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true
    })
    .replace(",", " -");
};
const getFileName = (url) => {
  if (!url) return "";
  return url.split("/").pop();
};

// Check if the URL is image or PDF
const getFileType = (url) => {
  if (!url) return null;
  const lower = url.toLowerCase();
  if (lower.endsWith(".pdf")) return "pdf";
  if (lower.endsWith(".jpg") || lower.endsWith(".jpeg") || lower.endsWith(".png")) return "image";
  return "other";
};

const formatAdminType = (value) => {
  if (!value) return "-";

  return value
    .split("_")                 // ["legal", "entity"]
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))  
    .join(" ");                // "Legal Entity"
};
const formatDOB = (date) => {
  if (!date) return "-";
  return new Date(date).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "2-digit",
  });
};

if (!details) return null;
  if (!selectedRow) return null;
  return (
    <>
      <Box
        sx={{
          border: '1px solid #E4E6EF',
          borderRadius: 2,
          px: 2,
          backgroundColor: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          minHeight: 55,
        }}
      >
        <Box
          sx={{ display: 'flex', alignItems: 'center', gap: 1.5, cursor: 'pointer' }}
          onClick={onClose}
        >
          <img src={back} style={{width:30,height:30}} />
          <CustomText
            sx={{ ...textStyles.h1, fontWeight: 500, fontSize: '14px', color: '#626F86', textAlign: 'center' }}
          >
         {t('clientsTrialDetails.back')} /{selectedRow.company}
          </CustomText>
        </Box>
      </Box>

      <Box sx={{ display: 'flex',flexDirection:isMobile?"column":"row", gap: 2, mt: 2, }}>
        <Box sx={{ width: isMobile?"100%":'50%',}}>
        {/* Left Panel */}
        <Box
          sx={{
          
            backgroundColor: '#fff',
            borderRadius: 2,
            border: '1px solid #E4E6EF',
            p: 3,
          }}
        >
          <CustomText sx={{ ...textStyles.h1, fontSize: 18, mb: 3, mt: 1, fontWeight: 600, color: '#003149', textAlign: 'left' }}>
  {t('clientsTrialDetails.accountDetails')}
          </CustomText>

          {/* <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2, mb: 2 }}>
            <img src={selectedRow.image || profileperson} alt="profile" style={{ width:120, height:120, borderRadius: '50%' }} />
          </Box> */}

  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2, mb: 2 }}>
            <img 
         
               src={profileImgSrc || dummy}
             alt="profile" style={{ width:140, height:140, borderRadius: '50%' }} />
          </Box>

          <Box>

      <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
     <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
        {t('clientsTrialDetails.id')}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"left" }}>
           {selectedRow.id}   </CustomText>  </Box>
           
                                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
              <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
        {t('clientsTrialDetails.status')}
              </CustomText>
            
             <Box sx={{ pointerEvents: "none" }}>
      <StatusDropdown
      currentStatus={selectedRow.status || "pending"}
      />
    </Box>
            </Box>


   <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
     <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
        {t('clientsTrialDetails.registeredOn')}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"right" }}>
         {convertUTCToLocalDateTime(selectedRow.date)}  </CustomText>  </Box>
          
   <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
     <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
        {t('clientsTrialDetails.companyAdmin')}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"left" }}>
        {selectedRow.admin} </CustomText>  </Box>
<Box sx={{display:"flex", justifyContent:"space-between", alignItems:"center", mb:2}}>
  <CustomText 
    sx={{ 
      ...textStyles.h1, 
      fontSize:16, 
      fontWeight: 400, 
      color: "#5E5C5C",
      textAlign:"left" 
    }}
  >
    {t("InviteDetails.dob")}
  </CustomText>

  <CustomText 
    sx={{ 
      ...textStyles.h1, 
      fontSize:15, 
      fontWeight: 400, 
      color: "#172B4D",
      textAlign:"left" 
    }}
  >
    {formatDOB(details.account_details.dob)}
  </CustomText>
</Box>
           <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
     <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
   {t('clientsTrialDetails.registeredEmail')}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"left" }}>
       {selectedRow.email} </CustomText>  </Box>

             <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
     <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
    {t('clientsTrialDetails.phone')}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"left" }}>
       {selectedRow.phone || '+34 612 345 678'} </CustomText>  </Box>

           
          </Box>

  
        </Box>
  
          
             <Box sx={{
                         backgroundColor: '#fff',
                      borderRadius: 2,
                      border: '1px solid #E4E6EF',
                      p: 3,
                      mt:2,
                   }}>
                        <CustomText sx={{ ...textStyles.h1, fontSize: 18, mb: 3, mt: 1, fontWeight: 600, color: '#003149', textAlign: 'left' }}>
                   {t("InviteDetails.subscriptionDetails")}
                    </CustomText>
                 
          
                        <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
               <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
                  {t("InviteDetails.subscriptionStatus")} </CustomText>
              <Box sx={{ pointerEvents: "none" }}>
      <StatusDropdown
      currentStatus={selectedRow.subscription_status || "trial"}
      />
    </Box> 
                      </Box> 
                 
                             <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
               <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
          {t("InviteDetails.subscription")}</CustomText>
         
          <CustomText 
  sx={{ 
    ...textStyles.h1, 
    fontSize: 15, 
    fontWeight: 400, 
    color: "#172B4D", 
    textAlign:"right" 
  }}
>
  {Array.isArray(selectedRow.subscription)
    ? selectedRow.subscription
        .map(formatSubscription)
        .join(", ")
    : formatSubscription(selectedRow.subscription)}
</CustomText>
              </Box>
                     
                        <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
               <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
            {t("InviteDetails.maxUsers")}</CustomText>
               <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"left" }}>
           {selectedRow.maxUsers}</CustomText>  </Box>
                   
               
                     
          
                 <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
               <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
          {t("InviteDetails.activationDate")}</CustomText>
               <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"right"  }}>
               {convertUTCToLocalDateTime(selectedRow.date)}</CustomText>  </Box>
                    
                 <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
               <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
          {t("InviteDetails.expiry")}</CustomText>
               <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"left" }}>
           {convertUTCToLocalDateTime(selectedRow.expirydate)} </CustomText>  </Box>
                   
                    </Box>
          </Box>
        <Box
          sx={{
           width: isMobile?"100%":'50%',
            backgroundColor: '#fff',
            borderRadius: 2,
            border: '1px solid #E4E6EF',
            p: 3,
          }}
        >
       
     <CustomText sx={{ ...textStyles.h1, fontSize: 18, mb: 3, mt: 1, fontWeight: 600, color: '#003149', textAlign: 'left' }}>
        {t('clientsTrialDetails.companyDetails')}
          </CustomText>

          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2, mb: 2 }}>
                    <img 
                   src={companyLogoSrc || dummy}
                     alt="profile" style={{ width:140, height:140, borderRadius: '50%' }} />
                  </Box>
           <CustomText sx={{ ...textStyles.h1, fontSize: 16, mb: 3, mt: 1, fontWeight: 600, color: '#003149', textAlign: 'left' }}>
{t('clientsTrialDetails.legalDetails')}
          </CustomText>


   <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
     <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
{t('clientsTrialDetails.workspaceCode')}</CustomText>
    
                  <Box
  sx={{ display: "flex", alignItems: "center", gap: 1, cursor: "pointer" }}
   onClick={() => {
    const code = details.company_details?.workspace_code;
    if (code) {
      navigator.clipboard.writeText(code);
      toast.success(t("copyCodeSuccess"));
    }
  }}
>
  <Box
    component="img"
    src={code}
    alt="code icon"
    sx={{ width: 20, height: 20 }}
  />

  <CustomText
    sx={{
      ...textStyles.h1,
      fontSize: 15,
      fontWeight: 400,
      color: "#172B4D",textAlign:"right" ,
      userSelect: "text"    // allows direct highlight + copy
    }}
  >
    {details.company_details?.workspace_code}
  </CustomText>
</Box>  </Box>
        
        
       <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
     <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
{t('clientsTrialDetails.legalName')}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"left" }}>
   {selectedRow.company}</CustomText>  </Box>
          <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
     <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
{t('clientsTrialDetails.industry')}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"left" }}>
   {details.company_details?.business_sector_industry || "-"}</CustomText>  </Box>

          <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
     <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
{t('clientsTrialDetails.tradeNo')}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"left" }}>
   {details.company_details?.trade_no || "-"}</CustomText>  </Box>
         
     <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
     <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
{t('clientsTrialDetails.registrationNo')}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"left" }}>
{details.company_details?.business_registration_no || "-"}</CustomText>  </Box>
        <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
     <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
{t('clientsTrialDetails.businessEmail')}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"left" }}>
{details.company_details?.business_email || "-"}</CustomText>  </Box>

       <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
     <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
{t('clientsTrialDetails.businessPhone')}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"left" }}>
{details.company_details?.business_phone_no || "-"}</CustomText>  </Box>
      





       <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
  <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C" }}>
    {t("inviteDetailsExtra.businessActivity")}
  </CustomText>
  <CustomText sx={{ ...textStyles.h1, fontSize: 15, fontWeight: 400, color: "#172B4D" }}>
    {details.company_details.business_activity || "-"}
  </CustomText>
</Box>
<Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
  <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C" }}>
  {t("inviteDetailsExtra.primaryColor")}
  </CustomText>

  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
    <Box sx={{ width: 20, height: 20, borderRadius: "4px", bgcolor: details.company_details.primary_color }} />
    <CustomText sx={{ fontSize: 14, color: "#172B4D" }}>{details.company_details.primary_color}</CustomText>
  </Box>
</Box>
<Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
  <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C" }}>
  {t("inviteDetailsExtra.secondaryColor")}
  </CustomText>

  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
    <Box sx={{ width: 20, height: 20, borderRadius: "4px", bgcolor: details.company_details.secondary_color }} />
    <CustomText sx={{ fontSize: 14, color: "#172B4D" }}>{details.company_details.secondary_color}</CustomText>
  </Box>
</Box>
<Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
 <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
  {t("inviteDetailsExtra.administratorType")}
  </CustomText>
  <CustomText sx={{ fontSize: 15, color: "#172B4D" }}>
    {formatAdminType(details.account_details.administrator_type)}

  </CustomText>
</Box>




<CustomText
        sx={{
          ...textStyles.h1,
          fontSize: 16,
          mb: 1,
          mt: 3,
          fontWeight: 600,
          color: "#003149",
          textAlign: "left",
        }}
      >
        {t("inviteDetailsExtra.adminDocument")}
      </CustomText>
      
      <Box
        sx={{
          border: "1px solid #E4E6EF",
          p: 2,
          borderRadius: 2,
          display: "flex",
          flexWrap: "wrap", 
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {/* LEFT SIDE ICON + FILE NAME */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <img
            src={
              getFileType(details.company_details.admin_document_url) === "pdf"
                ? document1
                : imageIcon
            }
            style={{ width: 28, height: 28 }}
          />
      
          <CustomText sx={{ fontSize: 14, color: "#172B4D" }}>
            {getFileName(details.company_details.admin_document_url)}
          </CustomText>
        </Box>
      
        {/* RIGHT SIDE VIEW BUTTON */}
        <Button
          variant="outlined"
          sx={{ textTransform: "none", fontSize: 12, borderRadius: "6px" }}
          onClick={() =>
            window.open(details.company_details.admin_document_url, "_blank")
          }
        >
          {t("inviteDetailsExtra.viewDocument")}
        </Button>
      </Box>


           <CustomText sx={{ ...textStyles.h1, fontSize: 16, mb: 3, mt: 3, fontWeight: 600, color: '#003149', textAlign: 'left' }}>
  {t('clientsTrialDetails.companyAddress')}
          </CustomText>

       <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
     <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
 {t('clientsTrialDetails.country')}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"left" }}>
{selectedRow.country}</CustomText>  </Box>
       
      <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
     <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
{t('clientsTrialDetails.province')}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"left" }}>
{details.admin_address_details?.community_province || "-"}</CustomText>  </Box>
                <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
     <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
 {t('clientsTrialDetails.city')}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"left" }}>
{details.admin_address_details?.city|| "-"}</CustomText>  </Box>

                 <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
     <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
  {t('clientsTrialDetails.street')}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"right"  }}>
{details.admin_address_details?.street_address|| "-"}</CustomText>  </Box>

  

   

        
        </Box>
      </Box>
 
    </>
  );
};

export default ClientsTrialDetails;